<template>
  <div>
    <vs-table
      ref="courseTable"
      stripe
      class="vs-con-loading__container"
      single
      @selected="handleSelectedCourse"
      pagination
      :max-items="itemsPerPage"
      search
      :data="coursesAndModules"
      v-scroll-to="'#tasksTable'"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
          <h3 class="ml-2">Courses & Modules</h3>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ coursesAndModules.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : coursesAndModules.length }} of {{ coursesAndModules.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="courseName">Course</vs-th>
        <vs-th sort-key="moduleName">Module</vs-th>
        <vs-th sort-key="moduleDescription">Description</vs-th>
        <vs-th sort-key="moduleProgress">Progress</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
          <vs-td :data="data[indextr].courseName">{{ item.courseName }}</vs-td>

          <vs-td :data="data[indextr].moduleName">{{ item.moduleName }}</vs-td>

          <vs-td :data="data[indextr].moduleDescription">{{ item.moduleDescription }}</vs-td>

          <vs-td>
            <div v-if="item.moduleProgress" style="text-align: center;">
              <vs-progress
                :percent="Number(item.moduleProgress)"
                :color="getProgressColor(Number(item.moduleProgress))"
                :height="12"
                class="shadow-md"
              />
              <small><span>{{item.moduleProgress.toFixed(2) + '%'}}</span></small>
            </div>
            <div v-else>
              <vs-chip color="danger">Not yet started</vs-chip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-divider v-show="showTasks" />
    <vs-table
      v-show="showTasks"
      id="tasksTable"
      ref="tasksTable"
      class="vs-con-loading__container"
      stripe
      single
      pagination
      max-items="10"
      search
      :data="tasks"
      @selected="handleSelectedTask"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
          <h3 class="ml-2">Completed Tasks</h3>
        </div>
        <div class="mb-4">
          <vs-checkbox v-model="showOnlyAssessed" color="success">Show Only Assessed</vs-checkbox>
        </div>
        <div class="p-3 mb-4 ml-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="loadTasks">
          <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-success">Refresh</span>
        </div>
      </div>
      <template slot="thead">
        <vs-th sort-key="taskName">Name</vs-th>
        <vs-th sort-key="taskType">Type</vs-th>
        <vs-th sort-key="completedDate">Date Completed</vs-th>
        <vs-th sort-key="statusName">Status</vs-th>
        <vs-th>Do Quiz Again</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">
          <vs-td :data="data[indextr].taskName">{{ task.taskName }}</vs-td>

          <vs-td :data="data[indextr].taskType">{{ task.taskType }}</vs-td>

          <vs-td
            :data="data[indextr].completedDate"
          >{{ task.completedDate.replace("T", " ").split('.')[0] }}</vs-td>

          <vs-td :data="data[indextr].statusName">
            <vs-chip v-show="statussesToShow.includes(task.statusId)" :color="getStatusColor(task.statusId)">{{ setStatusName(task.statusName) }}</vs-chip>
          </vs-td>

          <vs-td>
            <vs-button color="success" type="flat" icon-pack="feather" icon="icon-eye" @click.stop.prevent="getQuizTask(task.taskId)"></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup id="quizViewPopup" title="" :active.sync="quizViewIsActive" @close="handlePopupClose">
      <quiz-view :isCardActive="quizViewIsActive" :quizProp="quiz" @closePopup="closePopup" @refreshTasks="loadTasks" :popupXBtnClicked="popupXBtnClicked" @postEndLog="postEndLog" />
    </vs-popup>

  </div>
</template>

<script>
import quizView from './QuizView.vue';
export default {
  components: {
    quizView
  },
  data() {
    return {
      quizViewIsActive: false,
      quiz: {},
      itemsPerPage: 6,
      isMounted: false,
      loadingColor: "#fff",
      coursesAndModules: [],
      tasks: [],
      statussesToShow: [1, 2, 3, 4, 5, 6, 11],
      showTasks: false,
      showOnlyAssessed: false,
      moduleId: 0,
      popupXBtnClicked: false
    };
  },
  watch: {
    showOnlyAssessed: function() {
      this.$refs.tasksTable.currentx = 1;
      this.loadTasks();
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.courseTable.currentx;
      }
      return 0;
    }
  },
  methods: {
    postEndLog(payload) {
      var self = this;
      var onSuccess = function (response) {

      };
      self.$ajaxPost(self, "QuizTask/EndLogEntryByClosingPopup", payload, onSuccess);
    },
    handlePopupClose() {
      this.popupXBtnClicked = true;
    },
    closePopup() {
      this.quizViewIsActive = false;
    },
    loadCourseInfo() {
      const self = this;
      self.showLoadingOnElement("courseTable", 1, "corners");

      var onSuccess = function(response) {
        self.coursesAndModules = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.courseTable.$el);
      };

      self.$ajaxGet(self, "Student/ListCourseInfo", onSuccess, onFinally);
    },
    handleSelectedCourse(courseModule) {
      var self = this;
      self.tasks = [];
      self.showTasks = true;
      self.moduleId = courseModule.moduleId;
      self.loadTasks();
    },
    loadTasks() {
      var self = this;
      self.showLoadingOnElement("tasksTable", 1, "corners");

      var onSuccess = function (response) {
        self.tasks = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.tasksTable.$el);
      };

      self.$ajaxGet(
        self,
        "Student/ListStudentTasks?moduleId=" + self.moduleId + "&showOnlyAssessed=" + self.showOnlyAssessed,
        onSuccess,
        onFinally
      );
    },
    handleSelectedTask(task) {
      if(task.statusId == 2 || task.statusId == 3 || task.statusId == 7 || task.statusId == 11){
        let routeData = this.$router.resolve({ name: 'ViewAssessment', query: { TaskLogId: task.logId } });
        window.open(routeData.href, '_blank');
      }
      else{
        this.openAlert(task.statusId);
        return;
      }
    },
    getProgressColor(num) {
      if (num > 99) return "success";
      if (num <= 99) return "warning";
    },
    getStatusColor(statusId) {
      var self = this;
      if(statusId == 1)
        return 'primary';
      else if(statusId == 2 || statusId == 3 || statusId == 6 || statusId == 11)
        return 'success';
      else if(statusId == 4)
        return 'warning';
      else if(statusId == 5)
        return 'danger';
      return 'primary';
    },
    setStatusName(statusName) {
      if(statusName == 'Completed')
        return 'Waiting for Assessment';
      else if(statusName == 'Query')
        return 'Queried';
      else if(statusName == 'Moderated' || statusName == 'ReadyForStudentReview')
        return 'Assessed';
      else
        return statusName;
    },
    openAlert(status){
      if(status == 1) {
        this.$vs.dialog({
          color: 'warning',
          title: 'Information',
          text: 'Sorry, this task has not been assessed yet.',
          acceptText: 'OK'
        })
      }
      else if(status == 5) {
        this.$vs.dialog({
          color: 'danger',
          title: 'Information',
          text: 'You have already queried this assessment.',
          acceptText: 'OK'
        })
      }
      else if(status == 6) {
        this.$vs.dialog({
          color: 'success',
          title: 'Information',
          text: 'You have already accepted the assessment of this task.',
          acceptText: 'OK'
        })
      }
    },
    getQuizTask(taskId) {
      var self = this;
      self.popupXBtnClicked = false;
      self.quiz = {};
      self.showLoadingOnElement("tasksTable", 1, "corners");

      var onSuccess = function (response) {
        self.quiz = response.data;
        self.quizViewIsActive = true;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.tasksTable.$el);
      };

      self.$ajaxGet(
        self,
        "Student/GetQuizTask?moduleId=" + self.moduleId + "&quizTaskId=" + taskId,
        onSuccess,
        onFinally
      );
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    }
  },
  mounted() {
    var self = this;
    self.loadCourseInfo();
    self.isMounted = true;
  }
};
</script>

<style lang="scss">
#top-right-close {
  right: 0;
  position: absolute;
  top: 0;
  margin-right: 3px;
  margin-top: 3px;
}

#milestones-row {
  align-items: flex-end;
}

#delete-column {
  text-align: -webkit-center;
  text-align: -moz-center;
}

.numberinput {
  background: #ffffff;
  float: left;
}

#optionText_TextArea {
  width: 50%;
}

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
